import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './assets/scss/globalColors.scss';
import './assets/css/general.css';
import VueSvgInlinePlugin from "vue-svg-inline-plugin";
import "vue-svg-inline-plugin/src/polyfills";
import  { request } from './/assets/js/request.js';



var generalRequest = new request();

const app = createApp(App, {con:generalRequest});
app.config.globalProperties.$api = "https://mikele.efisen.se/apiCRM/";
generalRequest.apiUrl = "https://mikele.efisen.se/apiCRM/";

app.config.globalProperties.$scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // Omitir para un salto suave
    });
};
  
app.config.globalProperties.$scrollInTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'instant' // Omitir para un salto instantáneo sin animación
    });
};

app.use(VueSvgInlinePlugin);
app.use(VueSvgInlinePlugin, {
	attributes: {
		data: [ "src" ],
		remove: [ "alt" ]
	}
});

app.use(router);
app.mount('#app');


